import { show } from "./common";
import PrintingSelector from "./printing-selector";

export default class ProductPrintingOptions{
    private baseElement: HTMLElement;
    private hasPrice: boolean;
    private productId: number;
    private productGuid: string;
    private productCount: number;
    private isCalculatorActive: boolean;
    private isOutOfStock: boolean;

    static componentName = 'ProductDetailPrintingOptions';

    constructor(baseElement: HTMLElement){
        this.baseElement = baseElement;
        this.isCalculatorActive = this.baseElement.dataset.isCalculatorActive && this.baseElement.dataset.isCalculatorActive.toLowerCase() === 'true';
        this.hasPrice = this.baseElement.hasAttribute('data-has-price');
        this.productId = Number(this.baseElement.dataset.productId)
        this.productGuid = this.baseElement.dataset.productGuid;
    }

    // The component HTML now arrives via the page-level batched request (common.loadAsyncComponents).
    // NOTE: the constructor intentionally keeps reading its dataset values from the PLACEHOLDER element
    // (pre-existing behaviour) — only the loaded element assignment + after-load wiring happen here.
    initLoaded(loadedElement: HTMLElement): void {
        if (!loadedElement) {
            return;
        }
        this.baseElement = loadedElement;
        this.initAfterLoad();
    }

    private initAfterLoad(): void {
        this.isOutOfStock = this.baseElement.dataset.productOutOfStock && this.baseElement.dataset.productOutOfStock == 'True';
        this.initPrintingOptionLinks();
        this.showPrintingOptionsNavLink();
    }    
    
    private showPrintingOptionsNavLink() {
        const link = document.querySelector('#printing-options-nav-link') as HTMLElement;
        const list = document.querySelector('[data-component-part="position-list"]');
        link && list && show(link);
    }

    public initPrintingOptionLinks(): void {
        // Card mode: one link per position, opens the technologies popup.
        const cardLinks = this.baseElement.querySelectorAll('[data-printing-position-id]:not([data-printing-technology-id])');
        cardLinks && cardLinks.forEach(element => {
            new PrintingSelector(element as HTMLAnchorElement, this.hasPrice, this.productId, this.productGuid, this.productCount, this.isCalculatorActive, this.isOutOfStock).init();
        });

        // Table mode (positions without images): one link per position × technology row, no popup.
        const singleProductQuantity = Number(this.baseElement.dataset.singleProductQuantity);
        const rowLinks = this.baseElement.querySelectorAll('[data-printing-position-id][data-printing-technology-id]');
        rowLinks && rowLinks.forEach(element => {
            new PrintingSelector(element as HTMLAnchorElement, this.hasPrice, this.productId, this.productGuid, this.productCount, this.isCalculatorActive, this.isOutOfStock, singleProductQuantity || NaN).initTechnologyLink();
        });
    }

    public setProductCount(productCount: number){
        this.productCount = productCount;
    }

}
